import { resizeMediaUrl } from "./resize-media-url";
const fullscreenResizeMediaUrl = (params) => resizeMediaUrl({
  ...params,
  requiredWidth: params.requiredWidth * 2,
  requiredHeight: params.requiredHeight * 2
});
export {
  fullscreenResizeMediaUrl
};
//# sourceMappingURL=fullscreen-resize-media-url.js.map
